export default __webpack_public_path__ + "static/coaches-ba8d1bbe48fc7dc2c5423393c1c69502.png";